module.exports = __webpack_public_path__ + "static/media/inactive6dots.3ec0dbfd.svg";